import React, { useState } from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  FormControl, 
  FormControlLabel, 
  Radio, 
  RadioGroup, 
  TextField, 
  Typography 
} from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";

export const SuggestionFeedbackModal = ({ open, onClose, onSubmit }) => {
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleSubmit = () => {
    const reason = selectedReason === "otro" ? otherReason : selectedReason;
    onSubmit(reason);
    handleClose();
  };

  const handleClose = () => {
    setSelectedReason("");
    setOtherReason("");
    onClose();
  };

  const isSubmitDisabled = !selectedReason || (selectedReason === "otro" && !otherReason.trim());

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          Motivo de cambio de asignación
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Selecciona la razón por la que no utilizaste las opciones de asignación sugeridas
        </Typography>
        
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.target.value)}
          >
            <FormControlLabel
              value="La unidad no esta disponible"
              control={<Radio color="primary" />}
              label="La unidad no esta disponible"
              style={{ color: '#000' }}
            />
            <FormControlLabel
              value="La unidad no salió a ruta"
              control={<Radio color="primary" />}
              label="La unidad no salió a ruta"
              style={{ color: '#000' }}
            />
            <FormControlLabel
              value="otro"
              control={<Radio color="primary" />}
              label="Otro"
              style={{ color: '#000' }}
            />
          </RadioGroup>
        </FormControl>

        {selectedReason === "otro" && (
          <TextField
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            label="Especificar"
            value={otherReason}
            onChange={(e) => setOtherReason(e.target.value)}
            style={{ marginTop: 16 }}
          />
        )}
      </DialogContent>

      <DialogActions style={{ padding: "16px 24px" }}>
        <RegularButton color="transparent" onClick={handleClose}>
          Cancelar
        </RegularButton>
        <RegularButton 
          color="info" 
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
        >
          Confirmar
        </RegularButton>
      </DialogActions>
    </Dialog>
  );
};